import { FC, useEffect, useState } from 'react';
import { Button, Icon } from 'common-components';
import classNames from 'classnames';
import { useTranslationContext } from '../../contexts/translationContext';
import { TagsFilterProps } from './tagsFilterTypes';
import styles from './tagsFilter.module.scss';
import AdminSearch from '../search/search';
import Tag from '../../tag/tag';

const TagsFilterPopUp: FC<TagsFilterProps> = (props: TagsFilterProps) => {
    const {
        tags,
        selected,
        title,
        searchTitle,
        numberOfPapular,
        onApply,
        onClose,
        useBackground = true,
        useTitle = true,
        titles = ['PopularX', 'More']
    } = props;
    const [selectedTags, setSelectedTags] = useState<(string | object)[]>(selected);
    const [markedTags, setMarkedTags] = useState<string[]>([]);
    const [search, setSearch] = useState<string>('');
    const [numberOfPapularSelected, setNumberOfPapularSelected] = useState<number>(0);

    const { translate } = useTranslationContext();

    const calcPopularCount = () => {
        const popularStrings = tags.slice(0, numberOfPapular).map(item => item.name);
        const count = popularStrings.filter(value => selectedTags.includes(value)).length;
        setNumberOfPapularSelected(count);
    };

    useEffect(() => {
        if (search) {
            const filteredTags = tags.filter(item => item.displayName.toLowerCase().includes(search.toLowerCase()));
            setMarkedTags(filteredTags.map(item => item.name));
        } else {
            setMarkedTags([]);
        }
    }, [search]);

    useEffect(() => {
        setSelectedTags(selected);
        calcPopularCount();
    }, [selected]);

    useEffect(() => {
        calcPopularCount();
    }, [selectedTags]);

    const onTagClick = (tag: string) => {
        if (selectedTags.includes(tag)) {
            setSelectedTags(selectedTags.filter(item => item !== tag));
            console.log(selectedTags);
        } else {
            setSelectedTags([...selectedTags, tag]);
        }
    };

    const onApplyAction = () => {
        onApply(selectedTags);
    };

    return (
        <div className={styles['tags-filter']} style={{ background: !useBackground ? 'transparent' : undefined }}>
            <div
                className={styles.content}
                style={{ width: !useBackground ? '100%' : undefined, maxHeight: !useBackground ? '100%' : undefined }}
            >
                {useTitle && (
                    <div className={styles.top}>
                        <div className={styles.titles}>
                            <div className={styles.title}>{translate('AllX', { x: title })}</div>
                            {selectedTags.length > 0 && (
                                <div className={styles['selected-number']}>
                                    {translate('SelectedNumber', { number: String(selectedTags.length) })}
                                </div>
                            )}
                        </div>
                        <Icon name="grayClose" className={styles.close} onClick={() => onClose()} />
                    </div>
                )}
                <div className={styles['search-wrapper']}>
                    <AdminSearch
                        placeholder=""
                        onSearchChange={(search: string) => setSearch(search)}
                        firstString={searchTitle}
                    ></AdminSearch>
                </div>
                <div className={styles['tags-sections']}>
                    {numberOfPapular > 0 && (
                        <div className={styles['tags-section']}>
                            <div className={styles['section-titles']}>
                                <div className={styles.title}>{translate(titles[0], { x: title })}</div>
                                {numberOfPapularSelected > 0 && (
                                    <div className={styles.count}>{`(${numberOfPapularSelected})`}</div>
                                )}
                            </div>
                            <div className={styles.tags}>
                                {tags
                                    .slice(0, numberOfPapular)
                                    .map((tag: { name: string; displayName: string }, index: number) => (
                                        <Tag
                                            key={index}
                                            tagKey={tag.name}
                                            title={tag.displayName}
                                            isMarked={markedTags.includes(tag.name)}
                                            onTagClick={onTagClick}
                                            isCheckedCallback={selectedTags.includes(tag.name)}
                                        />
                                    ))}
                            </div>
                        </div>
                    )}
                    <div className={classNames(styles['tags-section'], styles['scroll-tags-section'])}>
                        <div className={styles['section-titles']}>
                            <div className={styles.title}>{translate(titles[1])}</div>
                        </div>
                        <div className={classNames(styles.tags, styles['scroll-tags'])}>
                            {tags
                                .slice(numberOfPapular)
                                .map((tag: { name: string; displayName: string }, index: number) => (
                                    <Tag
                                        key={index}
                                        tagKey={tag.name}
                                        title={tag.displayName}
                                        isMarked={markedTags.includes(tag.name)}
                                        onTagClick={onTagClick}
                                        isCheckedCallback={selectedTags.includes(tag.name)}
                                    />
                                ))}
                        </div>
                    </div>
                </div>
                <div className={styles['actions-wrapper']}>
                    {!useTitle && (
                        <Button type="learningPanelAdminCancel" text={translate('Cancel')} onClick={onClose} />
                    )}
                    <Button
                        type="learningPanelAdminActionButton"
                        text={translate('Apply')}
                        onClick={onApplyAction}
                        lowerCase={true}
                    />
                </div>
            </div>
        </div>
    );
};

export default TagsFilterPopUp;
